import { useEffect, useState } from 'react';
import { useGetAccountInfoQuery } from 'views/utils/graphql/graphql';

export enum OverseasRealEstateFatcaPageStep{
    ANSWER1 = '回答1',
    ANSWER2 = '回答2',
    ERROR1 = 'エラー1',
}

export enum AnswerRecorderType{    
    W8BenE = 1,
    Fatca,
}

export const useOverseasRealEstateFatca = (navigate: () => void) => {
    const [pageStep, setPageStep] = useState<OverseasRealEstateFatcaPageStep | null>(null);
    const [accountInfo, _] = useGetAccountInfoQuery({requestPolicy: 'network-only'});

    useEffect(() => {
        //w8-Ben-Eが未回答の場合
        if(accountInfo.data?.GetAccountInfo?.KFW8BenE == null){
            setPageStep(OverseasRealEstateFatcaPageStep.ANSWER1)
        }
        //w8-Ben-Eの回答がtrueであり、かつfatcaが未回答の場合
        else if(accountInfo.data?.GetAccountInfo?.KFW8BenE && accountInfo.data?.GetAccountInfo?.KFFatca == null){
            setPageStep(OverseasRealEstateFatcaPageStep.ANSWER2)
        }
        //w8-Ben-Eの回答がtrueであり、かつfatcaの回答がtrueである場合
        else if(accountInfo.data?.GetAccountInfo?.KFW8BenE && accountInfo.data?.GetAccountInfo?.KFFatca){
            navigate();
        }
        //いずれかの回答結果がfalseの場合
        else{
            setPageStep(OverseasRealEstateFatcaPageStep.ERROR1)
        }
    }, [accountInfo.data?.GetAccountInfo?.IsInvested, accountInfo.data?.GetAccountInfo?.KFW8BenE, accountInfo.data?.GetAccountInfo?.KFFatca])


    const nextPage = (isError?: boolean) => {
        if(isError === true){
            setPageStep(OverseasRealEstateFatcaPageStep.ERROR1)
            return;
        }

        switch (pageStep) {
            case OverseasRealEstateFatcaPageStep.ANSWER1:{
                //fatcaが未回答の場合
                if(accountInfo.data?.GetAccountInfo?.KFFatca == null){
                    setPageStep(OverseasRealEstateFatcaPageStep.ANSWER2)
                }
                //fatcaの回答がfalseの場合
                else if(accountInfo.data?.GetAccountInfo?.KFFatca === false){
                    setPageStep(OverseasRealEstateFatcaPageStep.ERROR1)               
                }
                //fatcaの回答がtrueの場合
                else{
                    navigate();
                }
                break;
            }
            case OverseasRealEstateFatcaPageStep.ANSWER2:{
                navigate();
                break;
            }
            case OverseasRealEstateFatcaPageStep.ERROR1:
            default:{
                break;
            }
        }
    }

    return{
        pageStep,
        nextPage
    }
};
